import errorImage from '../../../assets/images/error/errorImage/errorImage.png';

const ErrorPage = () => {
    return (
        <div className="error-page">
            <img src={errorImage} alt="Error" />
        </div>
    )
}

export default ErrorPage;